import { render, staticRenderFns } from "./ed-input.vue?vue&type=template&id=6023dbfa&scoped=true"
import script from "./ed-input.vue?vue&type=script&lang=js"
export * from "./ed-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023dbfa",
  null
  
)

export default component.exports